import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { LoadingLimits } from './LoadingLimits.types.tsx';

const RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';

export const arjSettingsLoadingLimitsResource: RouteResource<LoadingLimits> =
	createResource<LoadingLimits>({
		type: RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS,
		getKey: () => 'loading-limits-information',
		getData: async () => fetchJson('/rest/jpo/1.0/configuration'),
		maxAge: 0,
	});
